<div class="wrapper">
  <div class="circle">
    <div class="check-mark"></div>
  </div>
</div>
